import { Modal, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import ButtonLoader from "../../sharedComponent/ButtonLoader";
import { PostCallWithErrorResponse } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { ToastMsg } from "../TostMsg";

export default function BankDetails({
    userId,
    employeeId,
    orgId,
    bankData,
    refreshProfile,
}) {

    const [isUpdateBankDetails, setIsUpdateBankDetails] = useState(false)

    const [validated, setValidated] = useState(false)

    const [btnLoader, setBtnLoader] = useState(false)

    const [bankForm, setBankForm] = useState({
        BankName: "",
        NameOnAccount: "",
        AccountNo: "",
        IFSC: "",
        Branch: "",
        MICR: "",
    });

    useEffect(() => {
        setBankForm({
            BankName: bankData?.BankName || "",
            NameOnAccount: bankData?.NameOnAccount || "",
            AccountNo: bankData?.AccountNo || "",
            IFSC: bankData?.IFSC || "",
            Branch: bankData?.Branch || "",
            MICR: bankData?.MICR || "",
        });
    }, [bankData, isUpdateBankDetails]);

    const handleField = (key, val) => {
        setBankForm((prev) => ({ ...prev, [key]: val }));
    };

    const updateBankDetails = (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            setValidated(true);
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        const payload = {
            EmployeeId: Number(employeeId) || 0,
            OrgId: Number(orgId) || 0,
            BankName: bankForm.BankName || "",
            NameOnAccount: bankForm.NameOnAccount || "",
            AccountNo: bankForm.AccountNo || "",
            IFSC: bankForm.IFSC || "",
            Branch: bankForm.Branch || "",
            MICR: bankForm.MICR || "",
        };

        setBtnLoader(true);
        PostCallWithErrorResponse(
            ApiConfig.UPDATE_BANK_DETAILS,
            JSON.stringify(payload)
        )
            .then((res) => {
                setBtnLoader(false);
                if (res?.json?.Success) {
                    ToastMsg("success", res?.json?.Message || "Bank Details Updated Successfully");
                    handleClose();
                    if (typeof refreshProfile === "function") refreshProfile();
                } else {
                    ToastMsg("error", res?.json?.Message || "Something Went Wrong Try Again");
                }
            })
            .catch(() => {
                setBtnLoader(false);
                ToastMsg("error", "Something Went Wrong Try Again");
            });
    };

    const handleClose = () => {
        setIsUpdateBankDetails(false);
        setValidated(false);
    };

    return (
        <>
            <div className="">
                <div className="personal-heading-main">
                    <h3>Bank Details</h3>

                    <button
                        style={{
                            backgroundColor: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "18px",
                        }}
                    >
                        <i
                            class="fa-solid fa-pen-to-square"
                            onClick={() => {
                                setIsUpdateBankDetails(true)
                            }}
                        ></i>
                    </button>
                </div>
                <div className="lineSeperate2"></div>
                <div className="row p-0">
                    <div className="col-md-4 mt-2">
                        <label htmlFor=""> Full Name of Recipient</label>
                        <p className="mb-3">
                            {bankData?.NameOnAccount ? bankData.NameOnAccount : "-"}
                        </p>
                    </div>
                    <div className="col-md-4 mt-2">
                        <label htmlFor="">Account Number</label>
                        <p className="mb-3">
                            {bankData?.AccountNo ? bankData.AccountNo : "-"}
                        </p>
                    </div>
                    <div className="col-md-4 mt-2">
                        <label htmlFor="">IFSC Code</label>
                        <p className="mb-3">
                            {bankData?.IFSC ? bankData.IFSC : "-"}
                        </p>
                    </div>
                    <div className="col-md-4 mt-2">
                        <label htmlFor="">Bank Name</label>
                        <p className="mb-3">
                            {bankData?.BankName ? bankData.BankName : "-"}
                        </p>
                    </div>
                    <div className="col-md-4 mt-2">
                        <label htmlFor="">Bank Branch Location</label>
                        <p className="mb-3">
                            {bankData?.Branch ? bankData.Branch : "-"}
                        </p>
                    </div>
                    <div className="col-md-4 mt-2">
                        <label htmlFor="">MICR</label>
                        <p className="mb-3">
                            {bankData?.MICR ? bankData.MICR : "-"}
                        </p>
                    </div>
                </div>
            </div>
            <Modal
                show={isUpdateBankDetails}
                onHide={handleClose}
                size="lg"

                aria-labelledby="modal-90w"
                className="add-task-modal-main"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Bank Details</Modal.Title>
                </Modal.Header>
                <div className="lineSeperate"></div>
                <Form noValidate validated={validated} onSubmit={updateBankDetails}>
                    <Modal.Body>

                        <div className="row p-0">
                            <div className="col-md-4">
                                <label htmlFor="" className="mb-2 text-grey">
                                    Full Name of Recipient
                                    <span className="text-danger fw-bolder">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control tasKCategory1 mb-2"
                                    value={bankForm.NameOnAccount}
                                    onChange={(e) => handleField("NameOnAccount", e.target.value)}
                                    required
                                />
                                <div className="invalid-feedback">Enter Full Name of Recipient</div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="" className="mb-2 text-grey">
                                    Account Number
                                    <span className="text-danger fw-bolder">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control tasKCategory1 mb-2"
                                    value={bankForm.AccountNo}
                                    onChange={(e) => {
                                        if (!isNaN(e.target.value)) {
                                            handleField("AccountNo", e.target.value);
                                        }
                                    }}
                                    required
                                />
                                <div className="invalid-feedback">Enter Account Number</div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="" className="mb-2 text-grey">
                                    IFSC Code
                                    <span className="text-danger fw-bolder">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control tasKCategory1 mb-2"
                                    value={bankForm.IFSC}
                                    onChange={(e) => handleField("IFSC", e.target.value.toUpperCase())}
                                    required
                                />
                                <div className="invalid-feedback">Enter IFSC Code</div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="" className="mb-2 text-grey">
                                    Bank Name
                                    <span className="text-danger fw-bolder">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control tasKCategory1 mb-2"
                                    value={bankForm.BankName}
                                    onChange={(e) => handleField("BankName", e.target.value)}
                                    required
                                />
                                <div className="invalid-feedback">Enter Bank Name</div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="" className="mb-2 text-grey">
                                    Bank Branch Location
                                    <span className="text-danger fw-bolder">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control tasKCategory1 mb-2"
                                    value={bankForm.Branch}
                                    onChange={(e) => handleField("Branch", e.target.value)}
                                    required
                                />
                                <div className="invalid-feedback">Enter Bank Branch Location</div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="" className="mb-2 text-grey">
                                    MICR
                                </label>
                                <input
                                    type="text"
                                    className="form-control tasKCategory1 mb-2"
                                    value={bankForm.MICR}
                                    onChange={(e) => handleField("MICR", e.target.value)}
                                />
                            </div>
                        </div>

                    </Modal.Body>
                    <div className="lineSeperate"></div>
                    <div className="d-flex justify-content-end align-items-center mainBtnsSub">
                        <button
                            className="btn-width cancelBtn mx-3"
                            type="button"
                            onClick={handleClose}
                        >
                            Cancel
                        </button>
                        <button className="btn-width saveBtn" type="submit">
                            {btnLoader ? <ButtonLoader /> : "Update"}
                        </button>
                    </div>
                </Form>
            </Modal >
        </>
    )

}
